import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Heading } from '@instructure/ui-heading';
import { RadioInputGroup, RadioInput } from '@instructure/ui-radio-input';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import Bank from '../../../common/records/Bank';
import BankSelection from '../../../common/components/resources/BankSelection/presenter';
import t from '@instructure/quiz-i18n/es/format-message';
import { Modal, ModalHeader, ModalBody, ModalFooter, TextInput, XSMALL_SIDE_MARGIN } from '@instructure/quiz-common';
import { featureOn } from '../../../common/util/featureCheck';
export var AddToBankModal = /*#__PURE__*/function (_Component) {
  function AddToBankModal() {
    var _this;
    _classCallCheck(this, AddToBankModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AddToBankModal, [].concat(args));
    _defineProperty(_this, "state", {
      bankType: 'existing',
      newBankTitle: '',
      selectedBank: null
    });
    _defineProperty(_this, "copyBankEntry", function (entryId, bankId) {
      if (featureOn('instfs_bank_entry_movement_endpoints')) {
        return _this.props.moveBankEntryFromQuizEntry(_this.props.quizId, entryId, _this.props.entryType, bankId);
      } else {
        return _this.props.createBankEntry(bankId, _this.props.entryType, entryId);
      }
    });
    _defineProperty(_this, "addToBank", function (bankId) {
      _this.props.getEntry().then(function (entry) {
        return _this.copyBankEntry(entry.id, bankId);
      }).then(_this.props.onAdd)["catch"](function (e) {
        if (e.validationErrorsFromApi) {
          // Close the modal so the user can view the input validation errors and correct them
          _this.closeAction();
          _this.props.handleValidationErrorsFromApi(e.validationErrorsFromApi);
          return;
        }
        // Some other type of error occurred
        throw e;
      });
    });
    _defineProperty(_this, "continueAction", function () {
      _this.props.closeModal();
      _this.props.onContinue();
      if (_this.state.bankType === 'new') {
        var newBank = Bank.create({
          title: _this.state.newBankTitle,
          language: _this.context.locale
        });
        _this.props.createBank(newBank).then(function (bankData) {
          _this.addToBank(bankData.id);
        });
      } else {
        _this.addToBank(_this.state.selectedBank.id);
      }
    });
    _defineProperty(_this, "closeAction", function () {
      _this.props.closeModal();
    });
    _defineProperty(_this, "onBankSelection", function (e, option) {
      _this.setState({
        selectedBank: new Bank(option)
      });
    });
    _defineProperty(_this, "handleRadioChange", function (event, value) {
      _this.setState({
        bankType: value
      });
    });
    _defineProperty(_this, "onTitleChange", function (e) {
      _this.setState({
        newBankTitle: e.target.value
      });
    });
    return _this;
  }
  _inherits(AddToBankModal, _Component);
  return _createClass(AddToBankModal, [{
    key: "cancelButton",
    value: function cancelButton() {
      return /*#__PURE__*/React.createElement(Button, {
        onClick: this.closeAction,
        margin: XSMALL_SIDE_MARGIN
      }, t('Cancel'));
    }
  }, {
    key: "addToBankButton",
    value: function addToBankButton() {
      var _this$state = this.state,
        bankType = _this$state.bankType,
        newBankTitle = _this$state.newBankTitle;
      var disabled = bankType === 'existing' && !this.state.selectedBank || bankType === 'new' && (!newBankTitle || !newBankTitle.trim());
      return /*#__PURE__*/React.createElement(Button, {
        type: "button",
        color: "primary",
        onClick: this.continueAction,
        disabled: disabled,
        margin: XSMALL_SIDE_MARGIN,
        "data-automation": "sdk-add-to-bank-button"
      }, t('Add'));
    }
  }, {
    key: "renderBankTypeContent",
    value: function renderBankTypeContent() {
      if (this.state.bankType === 'existing') {
        return /*#__PURE__*/React.createElement(BankSelection, {
          onBankSelection: this.onBankSelection,
          selectedBank: this.state.selectedBank,
          "data-automation": "sdk-bank-selection"
        });
      }
      return /*#__PURE__*/React.createElement(TextInput, {
        onChange: this.onTitleChange,
        value: this.state.newBankTitle,
        renderLabel: t('New Bank Title'),
        type: "text"
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RadioInputGroup, {
        onChange: this.handleRadioChange,
        name: t('Bank Type'),
        defaultValue: this.state.bankType,
        description: /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Bank Type'))
      }, /*#__PURE__*/React.createElement(RadioInput, {
        value: "existing",
        label: t('Existing item bank')
      }), /*#__PURE__*/React.createElement(RadioInput, {
        value: "new",
        label: t('New item bank')
      })), /*#__PURE__*/React.createElement("br", null), this.renderBankTypeContent());
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Modal, {
        open: this.props.modalOpen,
        onDismiss: this.closeAction,
        size: "small",
        label: this.props.label,
        "data-automation": "sdk-add-to-bank-modal"
      }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(Heading, {
        level: "reset",
        as: "h2"
      }, this.props.label), /*#__PURE__*/React.createElement(CloseButton, {
        onClick: this.closeAction,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), /*#__PURE__*/React.createElement(ModalBody, null, this.renderContent()), /*#__PURE__*/React.createElement(ModalFooter, null, this.cancelButton(), this.addToBankButton()));
    }
  }]);
}(Component);
_defineProperty(AddToBankModal, "propTypes", {
  closeModal: PropTypes.func.isRequired,
  createBank: PropTypes.func.isRequired,
  moveBankEntryFromQuizEntry: PropTypes.func.isRequired,
  createBankEntry: PropTypes.func.isRequired,
  // Create the bank entry's entry, or clone it if it already exists. Should
  // always be provided when a source is provided.
  entryId: PropTypes.string.isRequired,
  // Only present for use in modalOpen key
  entryType: PropTypes.string.isRequired,
  // Resolve to the bank entry's entry, or create it if it does not yet exist.
  getEntry: PropTypes.func.isRequired,
  handleValidationErrorsFromApi: PropTypes.func,
  // not required for stimuli
  label: PropTypes.string.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  onAdd: PropTypes.func,
  onContinue: PropTypes.func,
  uiSet: PropTypes.func.isRequired,
  quizId: PropTypes.string.isRequired
});
_defineProperty(AddToBankModal, "defaultProps", {
  handleValidationErrorsFromApi: function handleValidationErrorsFromApi() {},
  onAdd: function onAdd() {},
  onContinue: function onContinue() {}
});
_defineProperty(AddToBankModal, "contextTypes", {
  locale: PropTypes.string
});
export default AddToBankModal;